module.exports = __webpack_public_path__ + "img/iconOperatingLog.7d2bf61b.svg";